// @flow
import * as React from 'react';
import {Modal} from "ctls/modal/Modal";
import styled from "styled-components";
import clsx from "clsx";

type Props = {
  children,
  clearFilter
};
type State = {};


/**
 * 신고하기 팝업.
 */
export class PopSearchFilter extends React.Component<Props, State> {
  private readonly ref: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);
    this.ref = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  handleClickOutside(e: MouseEvent) {
    if ((this.ref.current && !this.ref.current.contains(e.target as Node))) {
      this.props.clearFilter();
    }
  }


  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  render() {
    return (<>
        {(<Modal onClick={(e) => {
          e.stopPropagation();
        }}>
          <PopCnts className={clsx("")} ref={this.ref}>
            {this.props.children}
          </PopCnts>
        </Modal>)}
      </>
    );
  };
};


export const PopCnts = styled.div`
  .select-list {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    z-index: 10;
    display: none;

    left: 50%;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }

  .select-list li {
    color: #2A2C2F;
    padding: 1.2rem 1.8rem 1.2rem 1.6rem;
    border-bottom: 1px solid #C7D6EA;
    font-size: 1.2rem;
    font-weight: 500;
    user-select: none;
    cursor: pointer;
    min-width: 9.5rem;

    :hover {
      background: rgba(64, 126, 219, 0.1);
    }
  }

  .select-list li:last-child {
    border: none;
  }

  .doctype-kind-list {

  }

  .tag-search {
    left: 50%;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }


  @media screen and (max-width: 764px) {
    .doctype-kind-list {
      max-height: 400px;
      overflow-x: auto;
    }

    .prod-kind-list {
      max-height: 400px;
      overflow-x: auto;
    }


  }
`;